import { getJamClient } from '@/src/api/sdk/JamClient';
import { useAuth } from '@/src/store/auth.context';
import { useMemo } from 'react';

export const useJamClient = () => {
  const { authClient } = useAuth();

  return useMemo(() => getJamClient(authClient), [authClient]);
};
